import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const ContactForm = ({ formData, onFormChange }) => {
  const handleChange = (field, value) => {
    onFormChange({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-6">
      <h3 className="text-base font-bold">Your Details</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label>Full Name *</Label>
          <Input
            className="rounded-lg mt-1 h-10"
            value={formData.name}
            onChange={(e) => handleChange('name', e.target.value)}
            placeholder="Enter your name"
            required
            data-testid="quote-name-input"
          />
        </div>
        <div>
          <Label>Email *</Label>
          <Input
            type="email"
            className="rounded-lg mt-1 h-10"
            value={formData.email}
            onChange={(e) => handleChange('email', e.target.value)}
            placeholder="your@email.com"
            required
            data-testid="quote-email-input"
          />
        </div>
        <div>
          <Label>Phone *</Label>
          <Input
            type="tel"
            className="rounded-lg mt-1 h-10"
            value={formData.phone}
            onChange={(e) => handleChange('phone', e.target.value)}
            placeholder="10-digit mobile number"
            required
            data-testid="quote-phone-input"
          />
        </div>
        <div>
          <Label>City</Label>
          <Select value={formData.city} onValueChange={(v) => handleChange('city', v)}>
            <SelectTrigger className="rounded-lg mt-1 h-10">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Hyderabad">Hyderabad</SelectItem>
              <SelectItem value="Bangalore">Bangalore</SelectItem>
              <SelectItem value="Chennai">Chennai</SelectItem>
              <SelectItem value="Mumbai">Mumbai</SelectItem>
              <SelectItem value="Delhi">Delhi NCR</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div>
        <Label>Property Type</Label>
        <Select value={formData.property_type} onValueChange={(v) => handleChange('property_type', v)}>
          <SelectTrigger className="rounded-lg mt-1 h-10 max-w-xs">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="residential">Residential Apartment</SelectItem>
            <SelectItem value="villa">Independent Villa</SelectItem>
            <SelectItem value="commercial">Commercial Space</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label>Additional Notes (Optional)</Label>
        <Textarea
          className="rounded-lg mt-1"
          placeholder="Any specific requirements or preferences..."
          rows={3}
          value={formData.additional_notes}
          onChange={(e) => handleChange('additional_notes', e.target.value)}
        />
      </div>
    </div>
  );
};

export default ContactForm;
